'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductActivationPrompt = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Promptable = require('UIComponents/decorators/Promptable');

var _Promptable2 = _interopRequireDefault(_Promptable);

var _ActivationModalContainer = require('ui-addon-upgrades/_core/common/components/ActivationModalContainer');

var _ActivationModalContainer2 = _interopRequireDefault(_ActivationModalContainer);

var _PromiseHandlers = require('UIComponents/core/PromiseHandlers');

var _sources = require('ui-addon-upgrades/_core/common/data/upgradeData/properties/sources');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PRODUCT_ACTIVATION = _sources.sourceKeys.PRODUCT_ACTIVATION;


var _prompt = (0, _Promptable2.default)(_ActivationModalContainer2.default);

var ProductActivationPrompt = exports.ProductActivationPrompt = function ProductActivationPrompt(props) {
  var propsToPass = _extends({
    type: PRODUCT_ACTIVATION
  }, props);
  return _prompt(propsToPass).catch(_PromiseHandlers.rethrowError);
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.1086/js/_core/productActivation/ProductActivationPrompt.js
// module id = 651
// module chunks = 3 4